export default __webpack_public_path__ + "static/media/Stuff-training.2578e902.jpg";